<div ngbDropdown class="d-flex justify-content-center">
  <button class="btn btn-primary" id="dropdownBasic1" ngbDropdownToggle>
    <i class="mdi mdi-dots-vertical"></i>
  </button>

  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
    <ng-container *ngFor="let action of actions">
      <app-row-action [rowData]="rowData" [action]="action" (onActionClick)="onActionClicked($event)"></app-row-action>
    </ng-container>
  </div>
</div>
